import qs from "querystring";
import {DATUM_ORDER_ERROR, DATUM_ORDER_SUCCESS, FORGOT_LOADING, refreshToken} from "./sessionAction";
import {
    ASSET_LOADING,
    clearAssetData,
    GET_DATUM_GRAPH_DETAILS,
    GET_DATUM_GRAPH_DETAILS_FAIL,
    GET_DISPENSE_REPORTS,
    GET_DISPENSE_REPORTS_FAIL,
    GET_REFILL_REPORTS,
    GET_REFILL_REPORTS_FAIL,
    GET_REFILL_REPORTS_NOT_FOUND,
    SESSION_EXPIRED
} from "./getAssetActions";
import {nodeStaging, reposWebApi} from "./customerAPI";
import secureLocalStorage from "react-secure-storage";
import {apiCall} from "../utils/apiCall";
import fernet from "fernet";

export const DATUM_DECISION = 'DATUM_DECISION';
export const DATUM_LOADING = 'DATUM_LOADING';
export const DATUM_LOADING_FALSE = 'DATUM_LOADING_FALSE';
export const DATUM_ORDERS = 'DATUM_ORDERS';
export const DATUM_ORDER_ACCEPT = 'DATUM_ORDER_ACCEPT';
export const SOMETHING_WRONG = 'SOMETHING_WRONG';
export const DATUM_ASSET_LIST = 'DATUM_ASSET_LIST';
export const DATUM_ASSET_CREATE = 'DATUM_ASSET_CREATE';
export const DATUM_ORDER_UPDATE = 'DATUM_ORDER_UPDATE';
export const DATUM_ASSET_DELETE = 'DATUM_ASSET_DELETE';
export const DATUM_ASSET_UPDATE = 'DATUM_ASSET_UPDATE';
export const SHELL_LOADING = 'SHELL_LOADING';
export const SHELL_DATA = 'SHELL_DATA';
export const CLEAR_SUB_ASSET = "CLEAR_SUB_ASSET"
export const GET_SINGLE_SUB_ASSET = 'GET_SINGLE_SUB_ASSET';
export const SENSOR_DATA_LOADING = 'SENSOR_DATA_LOADING';
export const SENSOR_DATA = 'SENSOR_DATA';
export const GET_TELEMATICS_TYPE = 'GET_TELEMATICS_TYPE';
export const DATUM_ORDER_STATUS = 'DATUM_ORDER_STATUS';
export const DATUM_ORDER_STATUS_NULL = 'DATUM_ORDER_STATUS_NULL';
export const GET_RC_DETAILS_FAIL = 'GET_RC_DETAILS_FAIL';
export const GET_RC_DETAILS_NOT_FOUND = 'GET_RC_DETAILS_NOT_FOUND';
export const GET_RC_DETAILS = 'GET_RC_DETAILS';
export const SET_DATA = 'SET_DATA';
export const GET_DATUM_ENQUIRY = 'GET_DATUM_ENQUIRY';
export const GET_DATUM_ENQUIRY_FAIL = 'GET_DATUM_ENQUIRY_FAIL';
export const ELOCK_LOADING = "ELOCK_LOADING";
export const ALL_ELOCK = "ALL_ELOCK";
export const ELOCK_ACCEPT = "ELOCK_ACCEPT";
export const GET_ASSETS_LIST = "GET_ASSET_LIST";
export const GET_ASSET_FAIL = "GET_ASSETS_FAIL";
export const REFRESH_DATUM_ORDERS = "REFRESH_DATUM_ORDERS";
export const All_ASSET_LIST = "ALL_ASSET_LIST";
export const DATUM_F_ASSET_LIST = "DATUM_F_ASSET_LIST";
export const DATUM_F_SUB_ORDER_UPDATE = 'DATUM_F_SUB_ORDER_UPDATE';
export const GET_FUEL_LEVEL_Percent = "GET_FUEL_LEVEL_Percent";
export const GET_FUEL_LEVEL_SUCCESS = "GET_FUEL_LEVEL_SUCCESS";
export const GET_FUEL_LEVEL_FAILURE = "GET_FUEL_LEVEL_FAILURE";
export const GET_PRE_DATUMS = "GET_PRE_DATUMS";
export const GET_PRE_DATUMS_FAIL = "GET_PRE_DATUMS_FAIL";
export const PRE_DATUMS_LOADING = "PRE_DATUMS_LOADING";
export const SET_DATUM_DRAFT = "SET_DATUM_DRAFT";
export const CLEAR_DATUM_DRAFT = "CLEAR_DATUM_DRAFT";
export const GET_ALL_DATUM_ORDERS = "GET_ALL_DATUM_ORDERS";
export const GET_ALL_DATUM_ORDERS_FAIL = "GET_ALL_DATUM_ORDERS_FAIL";
export const ALL_DATUM_ORDERS_LOADING = "ALL_DATUM_ORDERS_LOADING";
export const GET_ORDER_STATUS_COUNT = "GET_ORDER_STATUS_COUNT";
export const GET_ORDER_STATUS_COUNT_FAIL = "GET_ORDER_STATUS_COUNT_FAIL";
export const ORDER_STATUS_COUNT_LOADING = "ORDER_STATUS_COUNT_LOADING";

export const RECONCILIATION_DIP_LOADING = "RECONCILIATION_DIP_LOADING";
export const RECONCILIATION_DIP_SUCCESS = "RECONCILIATION_DIP_SUCCESS";
export const RECONCILIATION_DIP_FAILURE = "RECONCILIATION_DIP_FAILURE";
export const RECONCILIATION_DIP_CANCELED = "RECONCILIATION_DIP_CANCELED";

export const dipRequestKey = (mode, params = {}) =>
    mode + ":" + JSON.stringify(Object.keys(params).filter((key) => key !== "limit" && key !== "offset")
        .sort().map((key) => [key, String(params[key])]));
export const selectDipRequest = (state, mode, params) =>
    state.getDatum?.reconciliationDip?.[dipRequestKey(mode, params)];

let dipRequestId = 0;
const requestReconciliationDip = (mode, params, enqueueSnackbar, {signal, method = "get", data, url, query, scope = params} = {}) =>
    async (dispatch) => {
        const key = dipRequestKey(mode, scope);
        const requestId = ++dipRequestId;
        let result;
        try {
            const endpoint = url || (mode === "months"
                ? "/customer/reconciliation/dip_months"
                : "/customer/reconciliation/" + (mode === "reminder" ? "remind_operator" : "dip_logs"));
            result = await dispatch(apiCall({
                url: endpoint, method, params: query || (method === "get" ? params : {}), data, signal,
                loadingType: RECONCILIATION_DIP_LOADING,
                successType: RECONCILIATION_DIP_SUCCESS,
                failType: RECONCILIATION_DIP_FAILURE,
                requestId,
                requestMeta: {key, mode, offset: params.offset || 0},
                requestKey: key, validateMeta: true,
            }));
        } catch (error) {
            result = {message: error.message, url: "reconciliation", method};
        }
        if (result === undefined || signal?.aborted) {
            dispatch({type: RECONCILIATION_DIP_CANCELED, meta: {key, mode, requestId}});
            return {ok: false, canceled: true};
        }
        if (result?.url && result?.method) {
            enqueueSnackbar?.(result.message || "Unable to complete the reconciliation request.", {variant: "error"});
            return {ok: false, message: result.message};
        }
        return {ok: true, data: result};
    };

export const getReconciliationDipAvailability = (assetId, enqueueSnackbar, options) =>
    requestReconciliationDip("availability", {asset_id: assetId}, enqueueSnackbar, options);
export const getReconciliationClosingAvailability = (assetId, startDate, enqueueSnackbar, options) =>
    requestReconciliationDip("closingAvailability", {asset_id: assetId, start_date: startDate}, enqueueSnackbar, options);
export const getReconciliationOrderHistory = (params, enqueueSnackbar, options = {}) =>
    requestReconciliationDip("orderHistory", {limit: 10, offset: 0, ...params}, enqueueSnackbar,
        {...options, url: "/customer/reconciliation/order_history"});
export const getReconciliationOrderDetail = (orderId, enqueueSnackbar, options = {}) =>
    requestReconciliationDip("orderDetail", {order_id: orderId}, enqueueSnackbar,
        {...options, url: "/customer/fuel_orders/detail"});
export const getReconciliationDipDates = (params, enqueueSnackbar, options) =>
    requestReconciliationDip("dates", {limit: 10, offset: 0, dip_logs_available: true, ...params}, enqueueSnackbar, options);
export const getReconciliationDipReadings = (params, enqueueSnackbar, options) =>
    requestReconciliationDip("readings", {limit: 10, offset: 0, ...params}, enqueueSnackbar, options);
export const getReconciliationDipMonths = (params, enqueueSnackbar, options) =>
    requestReconciliationDip("months", {limit: 10, offset: 0, ...params}, enqueueSnackbar, options);
export const remindReconciliationOperator = (assetId, enqueueSnackbar) =>
    requestReconciliationDip("reminder", {asset_id: assetId}, enqueueSnackbar,
        {method: "post", data: {asset_id: Number(assetId)}});

export const getReconciliationFuelOrders = (params, enqueueSnackbar, options = {}) =>
    requestReconciliationDip("fuelOrders", params, enqueueSnackbar, {...options, url: "/customer/fuel_orders"});
export const addReconciliationExternalRefill = (data, enqueueSnackbar) =>
    requestReconciliationDip("addExternal", {}, enqueueSnackbar,
        {url: "/customer/ext_order", method: "post", data, scope: {asset_id: data.customer_asset}});
export const getReconciliationExternalRefills = (params, enqueueSnackbar, options = {}) =>
    requestReconciliationDip("externalEntries", {limit: 10, offset: 0, ...params}, enqueueSnackbar,
        {...options, url: "/customer/ext_order"});
export const deleteReconciliationExternalRefill = (id, enqueueSnackbar) =>
    requestReconciliationDip("deleteExternal", {}, enqueueSnackbar,
        {url: "/customer/ext_order", method: "delete", scope: {id}, query: {id}});
export const runReconciliationAudit = (data, enqueueSnackbar) =>
    requestReconciliationDip("audit", {}, enqueueSnackbar,
        {url: "/customer/reconciliation/data", method: "post", data, scope: {asset_id: data.asset_id}});
export const getReconciliationHistory = (params, enqueueSnackbar, options = {}) =>
    requestReconciliationDip("history", {limit: 10, offset: 0, ...params}, enqueueSnackbar,
        {...options, url: "/customer/reconciliation/data"});
export const getReconciliationDetail = (id, enqueueSnackbar, options = {}) =>
    requestReconciliationDip("detail", {}, enqueueSnackbar,
        {...options, url: "/customer/reconciliation/data/" + encodeURIComponent(id), scope: {id}});
export const mailReconciliationReport = (id, enqueueSnackbar) =>
    requestReconciliationDip("mailReport", {}, enqueueSnackbar,
        {url: "/customer/reconciliation/mail_report", method: "post", data: {reconciliation_id: id}, scope: {id}});
export const getReconciliationCalculationDocument = (enqueueSnackbar) =>
    requestReconciliationDip("calculationDocument", {}, enqueueSnackbar,
        {url: "/customer/reconciliation/how_calculated"});

// Collect the eligible closing dates across the server's paginated month/date lists.
export const getReconciliationClosingDipDates = (assetId, startDate, enqueueSnackbar, options = {}) =>
    async (dispatch) => {
        const availability = await dispatch(getReconciliationClosingAvailability(assetId, startDate, enqueueSnackbar, options));
        if (!availability.ok) return availability;
        const minDate = availability.data.min_closing_date;
        if (!availability.data.has_closing_dip_log) return {ok: true, data: {minDate, dates: []}};
        const collect = async (action, params) => {
            const results = [];
            let offset = 0;
            while (!options.signal?.aborted) {
                const page = await dispatch(action({...params, limit: 10, offset}, enqueueSnackbar, options));
                if (!page.ok) return page;
                results.push(...(page.data.results || []));
                if (!page.data.next || !page.data.results?.length) return {ok: true, data: results};
                offset += 10;
            }
            return {ok: false, canceled: true};
        };
        const months = await collect(getReconciliationDipMonths, {asset_id: assetId, start_date: startDate});
        if (!months.ok) return months;
        const dates = [];
        for (const month of months.data) {
            const lastDay = new Date(Date.UTC(Number(month.year), Number(month.month), 0)).toISOString().slice(0, 10);
            if (lastDay < minDate) continue;
            const page = await collect(getReconciliationDipDates, {
                asset_id: assetId, start_date: startDate, month: month.month, year: month.year, dip_logs_available: true,
            });
            if (!page.ok) return page;
            dates.push(...page.data.filter((item) => item.date >= minDate && Number(item.count) > 0));
        }
        return {ok: true, data: {minDate, dates: getUniqueReconciliationDates(dates)}};
    };

const getUniqueReconciliationDates = (dates) =>
    Array.from(new Map(dates.map((item) => [item.date, item])).values()).sort((a, b) => a.date.localeCompare(b.date));


let search = '';
let abortsignal = '';
// Dedicated AbortController for refill reports to avoid race conditions
let refillAbortController = '';
export const getAllCustomerOrders = (requestBody, scrollToPreview, isDashoard, fetchMoreData) => {
    if (search) {
        search.abort();
    }

    search = new AbortController();
    const signal = search.signal;
    return async (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: DATUM_LOADING,
                payload: false
            })
        }
        reposWebApi.get(isDashoard ? '/order/get_customer_datum_orders' : '/order/get_all_customer_order', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: requestBody,
        }).then(res => {
            if (scrollToPreview) {
                dispatch({
                    type: DATUM_ORDERS,
                    payload: res?.data?.data
                })
                return scrollToPreview()
            }
            return dispatch({
                type: DATUM_ORDERS,
                payload: res?.data?.data
            })
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                return dispatch(getAllCustomerOrders(requestBody, scrollToPreview))
            }
            dispatch({
                type: SOMETHING_WRONG,
                payload: error
            });
        })
    }
}


export const acceptRejectOrder = (event, order_id, decision, f_order_id,compartment_no, enqueueSnackbar) => {
 
    return async (dispatch) => {
        dispatch({
            type: DATUM_DECISION,
            payload: true
        })
        const requestBody = {
            order_id,
            decision,
            f_order_id,
            compartment_no
        }
        reposWebApi.post('/order/customer_order_accept_reject', qs.stringify(requestBody), {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token"),
            }
        }).then(res => {

            const isAccepted = Number(decision) === 1;
            const successMessage = isAccepted ? 'Order Accepted!' : 'Order Cancelled!';
            enqueueSnackbar(res.status === 200 ? successMessage : res?.data?.data, {
                variant: res.status === 200 ? "success" : "error",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
            dispatch({
                type: DATUM_DECISION,
                payload: false
            })
            return dispatch({
                type: DATUM_ORDER_ACCEPT,
                payload: order_id
            })
 
            // dispatch(removeDatumOrder(order_id));
        }).catch((error) => {
            dispatch({
                type: DATUM_DECISION,
                payload: false
            })
           return  enqueueSnackbar('something went wrong!', {
                variant: "error",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
            // dispatch(getAllCustomerOrders());
        })
    }
}


export const listAllSubcustomers = (requestBody, enqueueSnackbar, scrollToPreview, fetchMoreData) => {
    if (search) {
        search.abort();
    }

    search = new AbortController();
    const signal = search.signal;
    return async (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: DATUM_LOADING,
            });
            dispatch(clearAssetData())
        }
        reposWebApi.get('/customer/list/subcustomer_for_customer_app', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: requestBody
        }).then(async res => {
            await dispatch({
                type: DATUM_ASSET_LIST,
                payload: res?.data?.data
            })
            scrollToPreview();
        }).catch(async (error) => {
            if (error?.response?.status === 401) {
                enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                dispatch({
                    type: DATUM_LOADING_FALSE
                })
                await dispatch(refreshToken())
                dispatch(listAllSubcustomers(requestBody, enqueueSnackbar, scrollToPreview))
            } else if (error?.response?.status >= 500) {
                enqueueSnackbar('Something went wrong, Please Try Again later', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                dispatch({
                    type: DATUM_LOADING_FALSE
                })
            }
            // dispatch(getAllCustomerOrders(requestBody, scrollToPreview, undefined));
        })
    }
}

export const listAllAsset = (requestBody, enqueueSnackbar, scrollToPreview, fetchMoreData) => {
    if (search) {
        search.abort();
    }

    search = new AbortController();
    const signal = search.signal;
    return async (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: DATUM_LOADING,
            });
            dispatch(clearAssetData())
        }
        reposWebApi.get('/customer/get_assets_list', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: requestBody
        }).then(async res => {
            await dispatch({
                type: All_ASSET_LIST,
                payload: res?.data?.data
            })
            scrollToPreview();
        }).catch(async (error) => {
            if (error?.response?.status === 401) {
                enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                dispatch({
                    type: DATUM_LOADING_FALSE
                })
                await dispatch(refreshToken())
                dispatch(listAllSubcustomers(requestBody, enqueueSnackbar, scrollToPreview))
            } else if (error?.response?.status >= 500) {
                enqueueSnackbar('Something went wrong, Please Try Again later', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                dispatch({
                    type: DATUM_LOADING_FALSE
                })
            }
            // dispatch(getAllCustomerOrders(requestBody, scrollToPreview, undefined));
        })
    }
}

export const createSubCustomer = (value, enqueueSnackbar, requestBody, scrollToPreview, handleClose, handlecall, refillGraph, capacity) => {
    return async (dispatch) => {
        dispatch({type: DATUM_LOADING});

        try {
            const res = await reposWebApi.post('/customer/manage/subcustomer', qs.stringify(value), {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
                }
            });

            if (res?.status === 201) {
                enqueueSnackbar("Sub_asset Created Successfully", {
                    variant: "success",
                    anchorOrigin: {vertical: "bottom", horizontal: "center"}
                });
            } else if (res?.status === 200) {
                enqueueSnackbar(capacity ? "Fuel tank capacity updated successfully" : "Sub_asset Updated Successfully", {
                    variant: "success",
                    anchorOrigin: {vertical: "bottom", horizontal: "center"}
                });
            } else if (res?.status === 202) {
                enqueueSnackbar("Sub_asset Deleted Successfully", {
                    variant: "success",
                    anchorOrigin: {vertical: "bottom", horizontal: "center"}
                });
            } else {
                enqueueSnackbar(res?.data?.data, {
                    variant: "success",
                    anchorOrigin: {vertical: "bottom", horizontal: "center"}
                });
            }

            dispatch({type: DATUM_ASSET_CREATE, payload: res?.data?.data});

            if (handlecall === false) {
                dispatch(getDatumRefillReports(refillGraph, enqueueSnackbar));
            } else {
                dispatch(listAllSubcustomers(requestBody, enqueueSnackbar, scrollToPreview));
            }
            handleClose();

            return {data: res?.data?.data, status: res?.status}

        } catch (error) {
            handleClose();
            if (error?.response?.status === 406) {
                enqueueSnackbar('Mobile already exists!', {
                    variant: "error",
                    anchorOrigin: {vertical: "bottom", horizontal: "center"}
                });
            } else if (error?.response?.status === 205) {
                enqueueSnackbar('Mobile already exists and is de-active', {
                    variant: "error",
                    anchorOrigin: {vertical: "bottom", horizontal: "center"}
                });
            } else if (error?.response?.status === 401) {
                enqueueSnackbar('Session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {vertical: "bottom", horizontal: "center"}
                });
                await dispatch(refreshToken());
                await dispatch(createSubCustomer(value, enqueueSnackbar, requestBody, scrollToPreview, handleClose, handlecall, refillGraph, capacity));
            } else if (error?.response?.status === 500) {
                enqueueSnackbar('Something went wrong! Please Try Again later', {
                    variant: "error",
                    anchorOrigin: {vertical: "bottom", horizontal: "center"}
                });
            } else {
                enqueueSnackbar(error?.response?.data?.data || 'An error occurred', {
                    variant: "error",
                    anchorOrigin: {vertical: "top", horizontal: "center"}
                });
            }
            dispatch({type: DATUM_LOADING_FALSE});
            return {data: error?.response, error: error?.response?.status}
        }
    };
};


export const editDatumOrder = (order_id, quantity, enqueueSnackbar, requestbody) => {
    return async (dispatch) => {
        dispatch({
            type: DATUM_LOADING
        })
        reposWebApi.post('/order/edit_datum_order', qs.stringify({
                order_id: order_id,
                quantity: quantity
            }), {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
                }
            }
        ).then(res => {
            dispatch({
                type: DATUM_ORDER_UPDATE,
                payload: res?.data?.data
            })
            enqueueSnackbar('Dispense order update successfully', {
                variant: "success",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
            dispatch(getAllCustomerOrders(requestbody))
        }).catch(async error => {
            if (error.response?.status === 401) {
                enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                await dispatch(refreshToken())
                dispatch(editDatumOrder())
            }
            enqueueSnackbar('Something went wrong..!, Please Try Again later', {
                variant: "error",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
        })
    }
}
export const handleDeleteSubCustomer = (enqueueSnackbar, handleClose) => {
    return async (dispatch) => {
        dispatch({
            type: DATUM_LOADING
        })
        reposWebApi.post('/customer/manage/subcustomer', qs.stringify({
                add: 0,
                update: 0,
                id: this.state.singleSubcustomer.id,
                delete: 1
            }), {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
                }
            }
        ).then(res => {
            dispatch({
                type: DATUM_ASSET_DELETE,
                payload: res?.data?.data
            })
            handleClose();
            enqueueSnackbar('Sub-Asset Deleted Successfully', {
                variant: "success",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
            dispatch(listAllSubcustomers());
        }).catch(async error => {
            if (error.response?.status === 401) {
                enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                await dispatch(refreshToken())
                dispatch(handleDeleteSubCustomer())
            }
            enqueueSnackbar('Something went wrong..!, Please Try Again later', {
                variant: "error",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
        })
    }
}

export const updateDetailsSubCustomer = (enqueueSnackbar) => {
    return async (dispatch) => {
        dispatch({
            type: DATUM_LOADING
        })

        reposWebApi.post('customer/manage/subcustomer', qs.stringify(
            {
                add: 0,
                update: 1,
                delete: 0,
                id: this.state.editId,
                name: this.state.editName,
                subasset_type: this.state.editAsset_type,
                mobile: this.state.editMobile,
            }), {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            }
        }).then(res => {
            dispatch({
                type: DATUM_ASSET_UPDATE,
                payload: res?.data?.data
            })
            enqueueSnackbar('Sub-Asset Details have been successfully updated', {
                variant: "success",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
            this.handleClose();
            this.listAllSubcustomers();
        }).catch(async error => {
            if (error.response?.status === 400) {
                enqueueSnackbar('Mobile already exists and is assigned to another sub-asset!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
            } else if (error.response?.status === 401) {
                enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                await dispatch(refreshToken())
                dispatch(updateDetailsSubCustomer())
            } else {
                enqueueSnackbar('Something went wrong..!, Please Try Again later', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
            }
        })

    }
}

export const datumOrder = (formData, enqueueSnackbar, history, setOpenDatum, setQuantity, assetCallData, scrollToPreview , datumData) => {
    return (dispatch) => {
        dispatch({
            type: FORGOT_LOADING,
        });
        reposWebApi.post('/order/place_datum_order', qs.stringify(formData), {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
        })
            .then(async response => {
                enqueueSnackbar("Dispense Order Placed: Your order is placed successfully!", {
                    variant: 'success', anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }
                });
                dispatch({
                    type: DATUM_ORDER_SUCCESS,
                    payload: response?.data
                });
                try {
                    await dispatch(listAllSubcustomers(assetCallData, enqueueSnackbar, scrollToPreview));
                    if (datumData?.datum_model === "RPS" || datumData?.asset_type === 10) {
                        history.push("/allDatumOrders/Ongoing", { datumData });
                    } else {
                        history.push("/allDatumOrders/Ongoing");
                    }                setOpenDatum(false);
                } catch (error) {
                    console.log(error);
                }
                setQuantity(0);
                dispatch(clearSubAsset());
            })
            .catch(error => {
                if (error?.response?.status === 401) {
                    dispatch({
                        type: SESSION_EXPIRED,
                    })
                }
                if (error?.response?.status === 406) {
                    dispatch({
                        type: DATUM_ORDER_ERROR,
                    })
                }
                enqueueSnackbar("Something went wrong", {
                    variant: 'error', anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }
                });
                dispatch({
                    type: DATUM_ORDER_ERROR,
                    payload: error
                });
            })
    }
};

export const shellTelematics = (id, enqueueSnackbar, scrollToPreview, requestBody, formData) => {
    if (search) {
        search.abort();
    }

    search = new AbortController();
    const signal = search.signal;

    return async (dispatch) => {
        dispatch({
            type: SHELL_LOADING
        })
        reposWebApi.get('/order/shell_details', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: {
                order_id: id
            },
        }).then(res => {
            dispatch({
                type: SHELL_DATA,
                payload: res?.data?.data
            })
            dispatch(getAllCustomerOrders(requestBody, scrollToPreview));
            dispatch(getDatumRefillReports(formData, enqueueSnackbar))
        }).catch(async (error) => {
            if (error?.response?.status === 401) {
                enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                await dispatch(refreshToken())
                dispatch(shellTelematics(id, enqueueSnackbar, scrollToPreview, requestBody))
            } else {
                enqueueSnackbar('Something went wrong, Please Try Again later', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
            }
            dispatch(getAllCustomerOrders());
        })
    }
}

export const get_telematics_types = () => {
    if (search) {
        search.abort();
    }

    search = new AbortController();
    const signal = search.signal;

    return async (dispatch) => {
        dispatch({
            type: SHELL_LOADING
        })
        reposWebApi.get('/customer/get_telematics_types', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
        }).then(res => {
            dispatch({
                type: GET_TELEMATICS_TYPE,
                payload: res?.data?.data
            })
        }).catch(async (error) => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(get_telematics_types())
            } else {
                console.log(error?.response)
            }
        })
    }
}

export const datumXSensorData = (name, asset_id, enqueueSnackbar) => {
    if (search) {
        search.abort();
    }

    return async (dispatch) => {
        dispatch({
            type: SENSOR_DATA_LOADING
        })
        nodeStaging.get('/sensor/getsensordata', {
            // headers: {
            //     Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            // },
            params: {
                name: name,
                asset_id: asset_id
            },
        }).then(res => {
            dispatch({
                type: SENSOR_DATA,
                payload: res?.data?.data
            })
        }).catch(async (error) => {
            if (error?.response?.status === 401) {
                enqueueSnackbar && enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                await dispatch(refreshToken())
                await dispatch(datumXSensorData(name, asset_id, enqueueSnackbar))
            } else {
                enqueueSnackbar && enqueueSnackbar(error?.message || 'Something went wrong, Please Try Again later', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
            }
        })
    }
}

export const datumXHistoricData = (formData, enqueueSnackbar, fetchMoreData) => {
    if (search) {
        search.abort();
    }

    search = new AbortController();
    const signal = search.signal;

    return (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: ASSET_LOADING,
            });
            dispatch(clearAssetData())
        }
        reposWebApi
            .get("/customer/get_historic_data", {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
                signal: signal,
                params: formData,
            })
            .then((response) => {
                dispatch({
                    type: GET_DISPENSE_REPORTS,
                    payload: response?.data?.data,
                    // .data.results,
                });
            })
            .catch(async (error) => {
                if (error.response?.status === 401) {
                    enqueueSnackbar("Session Expired..!", {
                        variant: 'warning',
                        horizontal: 'center'
                    });
                    await dispatch(refreshToken());
                    dispatch(datumXHistoricData(formData, enqueueSnackbar));
                } else {
                    enqueueSnackbar("'Something went wrong..! Please Try Again later'", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_DISPENSE_REPORTS_FAIL,
                        payload: true,
                    });
                }
            });
    };

}

export const getSubAssetRefillGraphDetails = (formData, loadChart, idDatumX) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
        await reposWebApi.get(idDatumX ? '/customer/get_graph_datumx' : '/customer/sub_asset/refill_graph', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: formData
        }).then(response => {
            dispatch({
                type: GET_DATUM_GRAPH_DETAILS,
                payload: response?.data?.data
            });
            loadChart(response?.data?.data);
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                // Retry the same request with original parameters
                dispatch(getSubAssetRefillGraphDetails(formData, loadChart, idDatumX))
            } else dispatch({
                type: GET_DATUM_GRAPH_DETAILS_FAIL,
                payload: error
            })
        });
    }
};

export const getDatumRefillReports = (formData, enqueueSnackbar, fetchMoreData, idDatumX) => {
    // Use a dedicated controller for this API to prevent request races
    if (refillAbortController) {
        try { refillAbortController.abort(); } catch (e) {}
    }
    refillAbortController = new AbortController();
    const signal = refillAbortController.signal;

    return (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: ASSET_LOADING,
            });
        }
        reposWebApi.get(idDatumX ? '/customer/get_historic_data' : "/customer/sub_asset/refill_list", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            signal: signal,
            params: formData,
        })
            .then((response) => {
                dispatch({
                    type: GET_REFILL_REPORTS,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getDatumRefillReports(formData, enqueueSnackbar, fetchMoreData));
                } else if (error?.response?.status === 404) {
                    enqueueSnackbar(error?.response?.data?.data?.error, {
                        variant: 'info',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_REFILL_REPORTS_NOT_FOUND
                    });
                } else if (error?.response?.status === 500 || error?.response?.status === 501 || error?.response?.status === 502) {
                    enqueueSnackbar("Something Went Wrong..!", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_REFILL_REPORTS_FAIL,
                        payload: true,
                    });
                } else {

                    dispatch({
                        type: GET_REFILL_REPORTS_FAIL,
                        payload: true,
                    });
                }
            });
    };
};

export const getRCDetails = (formData, enqueueSnackbar) => {
    return (dispatch) => {
        dispatch({
            type: DATUM_LOADING,
        });

        reposWebApi.get("/customer/get_rc_details", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            params: formData,
        })
            .then((response) => {
                dispatch({
                    type: GET_RC_DETAILS,
                    payload: response?.data?.data,
                });
                dispatch({
                    type: DATUM_LOADING_FALSE,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getRCDetails(formData));
                } else if (error?.response?.status === 404) {
                    enqueueSnackbar(error?.response?.data?.message, {
                        variant: 'info',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_RC_DETAILS_NOT_FOUND
                    });
                    dispatch({
                        type: DATUM_LOADING_FALSE,
                    });
                } else if (error?.response?.status === 400) {
                    enqueueSnackbar("RC Detail Not Registered", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_RC_DETAILS_FAIL,
                        payload: true,
                    });
                    dispatch({
                        type: DATUM_LOADING_FALSE,
                    });
                } else {
                    enqueueSnackbar("Something Went Wrong..!", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_RC_DETAILS_FAIL,
                        payload: true,
                    });
                    dispatch({
                        type: DATUM_LOADING_FALSE,
                    });
                }
            });
    };
};


export const getSingleSubAsset = (subAsset) => {
    return (dispatch) => {
        dispatch({
            type: GET_SINGLE_SUB_ASSET,
            payload: subAsset,
        });
    };
};

export const clearSubAsset = () => {
    return (dispatch) => {
        dispatch({
            type: CLEAR_SUB_ASSET,
        })
    }

};

export const handleCheckStatus = (value, handleStatusCall) => {
    let data = {
        "order_id": value
    }
    return (dispatch) => {
        reposWebApi.get('/order/get_order_status', {
            // headers: {
            //     Authorization: 'Bearer ' + 'EF94hjai5hKIy84brbf'
            // }
            params: data,
        }).then(res => {
            if (res.data.data.status !== "COM") {
                handleStatusCall(value);
            }
            dispatch({
                type: DATUM_ORDER_STATUS,
                payload: res.data.data
            })
        }).catch(err => {
            console.log(err);
        })
    }
}

export const datumEnquiry = (enqueueSnackbar) => {
    return async (dispatch) => {
        try {
            const response = await reposWebApi.get("/customer/get_datum_enquiry", {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
            });

            dispatch({
                type: GET_DATUM_ENQUIRY,
                payload: response,
            });

            enqueueSnackbar('Datum Enquiry sent Successfully', {
                variant: 'success',
                horizontal: 'center'
            });
        } catch (error) {
            if (error?.response?.status === 401 || error?.response?.status === 404) {
                enqueueSnackbar(error?.response?.data?.message, {
                    variant: 'info',
                    horizontal: 'center'
                });
            } else {
                dispatch({
                    type: GET_DATUM_ENQUIRY_FAIL,
                    payload: true,
                });
            }
        }
    };
};


export const setCheckStatusNull = () => {
    return (dispatch) => {
        dispatch({
            type: DATUM_ORDER_STATUS_NULL,
        })
    }
}

export const setData = (data) => {
    return (dispatch) => {
        dispatch({
            type: SET_DATA,
            payload: data
        })
    }
}

export const getAllELocks = (requestBody, scrollToPreview, isDashoard, fetchMoreData) => {
    if (search) {
        search.abort();
    }

    search = new AbortController();
    const signal = search.signal;
    return async (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: ELOCK_LOADING,
                payload: false
            })
        }
        reposWebApi.get('/customer/get_elogs', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: requestBody,
        }).then(res => {
            dispatch({
                type: ALL_ELOCK,
                payload: res?.data?.data
            })
            scrollToPreview();
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                return dispatch(getAllELocks(requestBody, scrollToPreview))
            }
            dispatch({
                type: SOMETHING_WRONG,
                payload: error
            });
        })
    }
}

export const acceptRejectElock = (event, log_id, decision, enqueueSnackbar, params, scrollToPreview) => {

    return async (dispatch) => {
        dispatch({
            type: ELOCK_LOADING
        })
        const requestBody = {
            log_id,
            decision
        }
        reposWebApi.post('/customer/customer_elock_accept_reject', qs.stringify(requestBody), {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            }
        }).then(res => {
            if (res.status === 200) {
                const message = res.data.data.toLowerCase();

                if (message.includes("accept")) {
                    enqueueSnackbar("Elock Accepted!", {
                        variant: "success",
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center"
                        }
                    });
                } else if (message.includes("reject")) {
                    enqueueSnackbar("Elock Rejected!", {
                        variant: "error",
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center"
                        }
                    });
                }
                // console.log("res",res.data.data)
                dispatch({
                    type: ELOCK_ACCEPT
                })
                dispatch(clearSubAsset());
                dispatch(getAllELocks(params, scrollToPreview, false));
            } else {
                enqueueSnackbar('Elock Rejected!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                dispatch(clearSubAsset());
                dispatch(getAllELocks(params, scrollToPreview, false));
            }
        }).catch((error) => {
            if (error.response.status === 202) {
                enqueueSnackbar('Rejected!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
            }
            dispatch(getAllELocks());
        })
    }
}

export const getAssetList = (requestBody) => {

    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
        reposWebApi.get('/customer/get_assets_list', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            params: requestBody
        }).then(res => {
            dispatch({
                type: GET_ASSETS_LIST,
                payload: res?.data?.data?.results
            })
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(getAssetList(requestBody))
            } else dispatch({
                type: GET_ASSET_FAIL,
                payload: error
            });
        })
    }
};

export const refreshDatumOrders = () => {
    return {
        type: REFRESH_DATUM_ORDERS
    };
};

export const listAllAssets = (requestBody, enqueueSnackbar, scrollToPreview, fetchMoreData) => {
    if (search) {
        search.abort();
    }

    search = new AbortController();
    const signal = search.signal;
    return async (dispatch) => {
        // if (!fetchMoreData) {
        //     dispatch({
        //         type: DATUM_LOADING,
        //     });
        //     dispatch(clearAssetData())
        // }
        reposWebApi.get('/customer/v2/list/asset_for_datum_app', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: requestBody
        }).then(async res => {
            await dispatch({
                type: DATUM_F_ASSET_LIST,
                payload: res?.data?.data
            })
            scrollToPreview();
        }).catch(async (error) => {
            if (error?.response?.status === 401) {
                enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                dispatch({
                    type: DATUM_LOADING_FALSE
                })
                await dispatch(refreshToken())
                dispatch(listAllAssets(requestBody, enqueueSnackbar, scrollToPreview))
            } else if (error?.response?.status >= 500) {
                enqueueSnackbar('Something went wrong, Please Try Again later', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                dispatch({
                    type: DATUM_LOADING_FALSE
                })
            }
        })
    }
}

export const editDatumFSubOrder = (f_order_id, payload, requestbody, enqueueSnackbar) => {
    return async (dispatch) => {
        dispatch({
            type: DATUM_LOADING
        })
        reposWebApi.put('/order/place_tank_orders', qs.stringify({
                f_order_id: String(f_order_id),
                compartment_capacity: payload?.compartment_capacity || [],
                compartment_no: payload?.compartment_no || [],
                r_asset_id: payload?.r_asset_id || []
            }), {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
                }
            }
        ).then(res => {
            dispatch({
                type: DATUM_ORDER_UPDATE,
                payload: res?.data?.data
            })
            enqueueSnackbar('Changes saved successfully', {
                variant: "success",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
            dispatch(getAllCustomerOrders(requestbody))
        }).catch(async error => {
            if (error.response?.status === 401) {
                enqueueSnackbar('session Expired, retrying for new session!', {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    }
                })
                await dispatch(refreshToken())
                dispatch(editDatumOrder())
            }
            enqueueSnackbar('Something went wrong..!, Please Try Again later', {
                variant: "error",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                }
            })
        })
    }
}

export const getFuelLevel = (assetId) => {
  return apiCall({
    url: `/customer/get_fuel_level`,
    params: { asset_id: assetId },
    method: "get",
    loadingType: GET_FUEL_LEVEL_Percent,
    successType: GET_FUEL_LEVEL_SUCCESS,
    failType: GET_FUEL_LEVEL_FAILURE,
  });
};

export const getPreDatumsList = (params, fetchMoreData) => {
    return apiCall({
        url: "/customer/list/pre_datums",
        params: params,
        method: "get",
        successType: GET_PRE_DATUMS,
        failType: GET_PRE_DATUMS_FAIL,
        fetchMoreData,
        loadingType: PRE_DATUMS_LOADING,
    });
};

export const clearDatumDraft = () => {
    return (dispatch) => {
        dispatch({
            type: CLEAR_DATUM_DRAFT
        })
    }
}

// Get All Datum Orders
export const getAllDatumOrders = (params = {}, fetchMoreData = false) => {
    const queryParams = {
        ...params,
        limit: params.limit || 10,
        offset: params.offset || 0
    };

    return async (dispatch) => {
        try {
            // if (!fetchMoreData) {
                dispatch({
                    type: ALL_DATUM_ORDERS_LOADING
                });
            // }

            const response = await reposWebApi.get(
                '/order/get_all_datum_orders',
                {
                    headers: {
                        Authorization:
                            'Bearer ' + secureLocalStorage.getItem("access_token")
                    },
                    params: queryParams
                }
            );
            let secret = new fernet.Secret('BbSePhsFh4eJ5U5hUkfTm_Y1R1wS4PhWnLltHUPiMW8=');

            let toke = new fernet.Token({
                secret: secret,
                token: response.data,
                ttl: 0
            });

            let decryptedData = JSON.parse(toke.decode());
            dispatch({
                type: GET_ALL_DATUM_ORDERS,
                payload: decryptedData,
                fetchMoreData
            });

            return decryptedData;

        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return dispatch(getAllDatumOrders(params, fetchMoreData));
            }

            let errorPayload = error?.response?.data;

            try {
                if (typeof error?.response?.data === "string") {

                    let secret = new fernet.Secret('BbSePhsFh4eJ5U5hUkfTm_Y1R1wS4PhWnLltHUPiMW8=');

                    let toke = new fernet.Token({
                        secret: secret,
                        token: error.response.data,
                        ttl: 0
                    });

                    errorPayload = toke.decode();
                }
            } catch (e) {
                console.warn("Error decryption failed");
            }

            dispatch({
                type: GET_ALL_DATUM_ORDERS_FAIL,
                payload: errorPayload
            });

            throw error;
        }
    };
};

// Get Order Status Count
export const getOrderStatusCount = (params = {}) => {
    return async (dispatch) => {
        try {
            dispatch({ type: ORDER_STATUS_COUNT_LOADING });

            const response = await reposWebApi.get('/order/get_order_status_count', {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
                },
                params: params
            });

            let secret = new fernet.Secret('BbSePhsFh4eJ5U5hUkfTm_Y1R1wS4PhWnLltHUPiMW8=');

            let toke = new fernet.Token({
                secret: secret,
                token: response.data,
                ttl: 0
            });

            let decryptedData = JSON.parse(toke.decode());

            dispatch({
                type: GET_ORDER_STATUS_COUNT,
                payload: decryptedData
            });

            return response.data;
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return dispatch(getOrderStatusCount(params));
            }
            let errorPayload = error?.response?.data;

            try {
                if (typeof error?.response?.data === "string") {

                    let secret = new fernet.Secret('BbSePhsFh4eJ5U5hUkfTm_Y1R1wS4PhWnLltHUPiMW8=');

                    let toke = new fernet.Token({
                        secret: secret,
                        token: error.response.data,
                        ttl: 0
                    });

                    errorPayload = toke.decode();
                }
            } catch (e) {
                console.warn("Error decryption failed");
            }
            
            dispatch({ type: GET_ORDER_STATUS_COUNT_FAIL, payload: errorPayload });
            throw error;
        }
    };
};